import React, { memo } from 'react';

import classNames from 'classnames';

import { UiText } from '@shared/ui';

import cls from './TaskTitle.module.css';

interface TaskTitleProps {
    taskIsDone: boolean;
    taskTitle: string;
    isOverdue: boolean;
    isCompleted: boolean;
    classes?: string;
}

export const TaskTitle = memo(
    ({ taskIsDone, taskTitle, isOverdue, isCompleted, classes }: TaskTitleProps) => (
        // <h3
        //     className={classNames(
        //         cls.BoardListItem_Title,
        //         taskIsDone && cls.BoardListItem_isDone,
        //         isOverdue && cls.isOverdue,
        //         isCompleted && cls.isCompleted
        //     )}
        //     title={taskTitle}
        // >
        //     <span className={classes}>{taskTitle}</span>
        // </h3>

        <UiText
            tag="h3"
            title={taskTitle}
            className={classNames(
                cls.BoardListItem_Title,
                taskIsDone && cls.BoardListItem_isDone,
                isOverdue && cls.isOverdue,
                isCompleted && cls.isCompleted
            )}
        >
            <span className={classes}>{taskTitle}</span>
        </UiText>
    )
);
